import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateTime } from 'luxon';
import { lastValueFrom } from 'rxjs';
import { DocInfoModalComponent } from 'src/app/modals/doc-info-modal/doc-info-modal.component';
import { NewTalonComponentMobile } from 'src/app/modals/new-talon-mobile/talon.component';
import { ConfigService } from 'src/app/services/application/config.service.';
import { RecordService } from 'src/app/services/record.service';
import { Utils } from 'src/app/services/utils';
import { AlertService } from 'src/lib/ariadna/alert';
import {
    IDepartment,
    IDoctorSearchResult,
    IDep,
    IDoctor,
    IRecTalon,
    IRecTalonInit,
    IRnumbDate,
    ISpec,
    ITalonModal,
    ITalonsDaySetParams,
} from '../../../interfaces/record.interfaces';
import { CalendarService } from '../../../services/calendar.service';
import {
    formatApiDate,
    formatUiDate,
    getDateKey,
    toDateTime,
    uniqueDateTimesByDay,
} from '../../../shared/date/date.utils';
import { strToDate } from '../../application/global.function';
import { CalendarHeader } from '../../talonpicker/header/calendar-header.component';

@Component({
    selector: 'rec-services-mobile',
    templateUrl: './rec-services-mobile.component.html',
    styleUrls: ['./rec-services-mobile.component.scss'],
    standalone: false,
})
export class RecServicesMobileComponent implements OnInit, OnChanges {
    @Input() public selectedDoctor: IDoctorSearchResult | undefined;
    @Input() public params!: IRnumbDate;
    @Output() public closePicker: EventEmitter<void> = new EventEmitter<void>();

    public doctors: IDoctorSearchResult[] = [];
    public selectedSpec: ISpec | null = null;
    public openMobileTemplate: boolean = false;
    public loading: boolean = true;
    public talonListAll: IRecTalon[] = [];
    public talonList: IRecTalon[] = []; // Массов дней - активный
    public paramsTalonPicker!: IRnumbDate;
    public selectedDep: IDep | IDepartment | null = null;
    public selectedDeps: Array<number> = []; // Список выбранных депов
    public showDropdown = false;
    public depList: IDep[] = [];
    public talonListFiltered: IRecTalon[] = [];
    public activeDays: DateTime[] = []; // NOT sorted by date
    public selectedDay: DateTime | null = DateTime.local();
    public currentDay: Date | null | undefined = null;
    public selectedDate: Date | null = new Date(); // Выбрана дата
    public showCalendarIcon: boolean = false;

    public minDate: DateTime = DateTime.local().startOf('year');
    public maxDate: DateTime = DateTime.local().endOf('year');
    public pickedTalon: IRecTalon | null = null;
    public headerTxt = ''; // Заголовок
    public isSlideRight = false;
    public isSlideLeft = false;

    public header = CalendarHeader;
    public isCalendarActive: boolean = false;
    public depPicked: boolean = false;
    public paramsData: IRecTalonInit | null = null; // параметры инициализации
    public dateFilter = (date: DateTime) => this.isActiveDay(date);
    public emptyDep: IDep = {
        keyId: 0,
        text: '',
    };

    public constructor(
        private rs: RecordService,
        private config: ConfigService,
        private modalService: NgbModal,
        private alertService: AlertService,
        private modal: MatDialog,
        private cs: CalendarService,
        private router: Router, // public dialogRef: MatDialogRef<NewTalonComponentMobile>
    ) {}

    public ngOnInit(): void {}
    public prevDate(): void {
        if (!this.selectedDate) return;
        const currentDate = toDateTime(this.selectedDate).startOf('day');

        // собираем уникальные даты из talonListAll
        const uniqueDates = [
            ...new Set(
                this.talonListAll.map((talon) =>
                    toDateTime(talon.dtBegin).startOf('day').toMillis(),
                ),
            ),
        ].sort((a, b) => a - b);

        const currentIndex = uniqueDates.findIndex(
            (date) => date === currentDate.toMillis(),
        );

        if (currentIndex > 0) {
            const prevDate = toDateTime(uniqueDates[currentIndex - 1]);
            this.clickDate(prevDate);
            this.talonListFiltered = this.filterTalons();
        }
        //Анимация
        this.isSlideLeft = true;
        setTimeout(() => {
            this.isSlideLeft = false;
        }, 1000);
    }

    public nextDate(): void {
        if (!this.selectedDate) return;
        const currentDate = toDateTime(this.selectedDate).startOf('day');

        // собираем уникальные даты из talonListAll
        const uniqueDates = [
            ...new Set(
                this.talonListAll.map((talon) =>
                    toDateTime(talon.dtBegin).startOf('day').toMillis(),
                ),
            ),
        ].sort((a, b) => a - b);

        const currentIndex = uniqueDates.findIndex(
            (date) => date === currentDate.toMillis(),
        );

        if (currentIndex < uniqueDates.length - 1) {
            const nextDate = toDateTime(uniqueDates[currentIndex + 1]);
            this.clickDate(nextDate);
            this.talonListFiltered = this.filterTalons();
        }
        //Анимация
        this.isSlideRight = true;
        setTimeout(() => {
            this.isSlideRight = false;
        }, 1000);
    }

    public changeDate(direction: number): void {
        if (this.selectedDate) {
            this.selectedDate = new Date(
                this.selectedDate.setDate(
                    this.selectedDate.getDate() + direction,
                ),
            );
        }
    }

    public isFirstDate(): boolean {
        if (!this.selectedDate || !this.talonListAll.length) return true;

        const uniqueDates = [
            ...new Set(
                this.talonListAll.map((talon) =>
                    toDateTime(talon.dtBegin).startOf('day').toMillis(),
                ),
            ),
        ].sort((a, b) => a - b);

        return (
            toDateTime(this.selectedDate).startOf('day').toMillis() ===
            uniqueDates[0]
        );
    }

    public isLastDate(): boolean {
        if (!this.selectedDate || !this.talonListAll.length) return true;

        const uniqueDates = [
            ...new Set(
                this.talonListAll.map((talon) =>
                    toDateTime(talon.dtBegin).startOf('day').toMillis(),
                ),
            ),
        ].sort((a, b) => a - b);

        return (
            toDateTime(this.selectedDate).startOf('day').toMillis() ===
            uniqueDates[uniqueDates.length - 1]
        );
    }

    public onDateSelected(date: DateTime) {
        this.clickDate(date);
        this.talonListFiltered = this.filterTalons();
    }

    /* ПОлучение списка талонов */
    public initTalons(t: IRecTalonInit) {
        this.paramsData = t;
        this.talonListAll = this.paramsData.talons;
    }

    public async ngOnChanges(changes: any) {
        if (changes.params) {
            this.loading = true;
            this.maxDate = toDateTime(changes.params.currentValue.periodEnd);
            await Promise.all([
                await this.getTalonList(changes.params.currentValue),
                await this.getDepList(changes.params.currentValue),
            ]).catch((e) => {
                this.alertService.error('Не удалось получить список талонов');
                console.error(e);
            });
            this.activeDays = this.filterActiveDays();
            this.selectedDay = this.findFirstActiveDay();
            this.talonListFiltered = this.filterTalons();

            this.updateCalendar();
            this.loading = false;
            this.pickedTalon = null;
            this.currentDay = this.selectedDay?.toJSDate() ?? new Date();
            const data: ITalonsDaySetParams = {
                dt: this.currentDay ? this.currentDay : new Date(),
                dep: this.selectedDep ? this.selectedDep : undefined,
            };
            this.initDay(data);
        }
    }

    private isActiveDay(day: DateTime) {
        return this.activeDays.some((activeDay) =>
            day.hasSame(activeDay, 'day'),
        );
    }

    public async openTalonModal(event: MouseEvent, talon: IRecTalon | null) {
        event.stopPropagation();
        if (this.pickedTalon) {
            talon = this.pickedTalon;
        }

        if (talon?.rnumbId !== this.pickedTalon?.rnumbId) {
            this.pickedTalon = talon;
        }

        if (this.params?.srv?.isTelemed !== talon?.isTelemed) {
            this.loading = false;
            return;
        }

        // if (!talon) return;
        let data: ITalonModal = {
            rnumbId: null,
            info: {
                docdepID: this.pickedTalon?.docDepId,
                beginDate: this.pickedTalon?.dtBegin,
            },
            srv: this.params.srv,
            paramCansel: false,
            infoDoc: this.params.infoDoc,
        };

        try {
            if (talon?.isInterval && talon.isInterval > 0 && talon.intervalId) {
                // console.log(talon);
                const { guid } = await lastValueFrom(
                    this.rs.getRnumbCreateInterval(
                        talon?.intervalId,
                        talon?.datBeginStr,
                        talon?.datEndStr,
                    ),
                );

                if (!guid)
                    throw new Error('Ошибка создания интервального номерка');
                data.rnumbId = guid;
                await lastValueFrom(
                    this.rs.setRnumbBlStatus(data.rnumbId as number),
                );
            } else if (talon?.rnumbId) {
                data.rnumbId = talon.rnumbId;

                await lastValueFrom(
                    this.rs.setRnumbBlStatus(data.rnumbId as number),
                );
            }

            this.alertService.success(
                `Талон успешно зарезервирован, № талона: ${data.rnumbId}`,
            );

            let dialogRefOptions = {
                width: 'auto',
                // height: '90vh',
                maxWidth: 'auto',
                minWidth: 'auto',
                closeOnNavigation: true,
                data,
            };

            // Check screen width and adjust dialog options if needed
            if (window.matchMedia('(max-width: 768px)').matches) {
                dialogRefOptions.width = '90vw';
                dialogRefOptions.maxWidth = '100vw';
                dialogRefOptions.minWidth = '90vw';
            }

            const modalRef = this.modal.open(
                NewTalonComponentMobile,
                dialogRefOptions,
            );

            modalRef.afterClosed().subscribe((result) => {
                // console.log(result);
                if (result && result.unlockTalon) {
                    lastValueFrom(this.rs.getRnumbUnlock(result.rnumbID))
                        .then((value) => {
                            this.alertService.success(
                                `Талон успешно разблокирован, № талона: ${result.rnumbID}`,
                            );
                        })
                        .catch((error: any) => {
                            this.alertService.error(
                                `Не удалось разблокировать талон с id ${result.rnumbID}: ${Utils.getErrorMessage(error)}`,
                            );
                        });
                }
            });
        } catch (error: any) {
            const errorMessage = Utils.getErrorMessage(error);
            console.error(`Не удалось создать интервал: ${errorMessage}`);
            this.alertService.error(
                `Не удалось записаться на номерок: ${errorMessage}`,
            );
        }
    }

    public clickTalon(event: Event, talon: IRecTalon): void {
        // if (this.talonDisable(talon)) {
        this.pickedTalon = talon;
        // }
    }

    public findFirstActiveDay() {
        let firstActiveDay = this.activeDays[0];
        this.activeDays.forEach((day) => {
            if (firstActiveDay.toMillis() > day.toMillis())
                firstActiveDay = day;
        });
        return firstActiveDay;
    }

    public updateCalendar() {
        // if (this.calendar) this.calendar.updateTodaysDate();
    }

    private async getTalonList(params: IRnumbDate) {
        this.talonListAll = await lastValueFrom(this.rs.getRnumbListv2(params));
        this.talonListAll.forEach((talon, i) => {
            this.talonListAll[i].dtBegin = strToDate(talon.datBeginStr);
        });
    }

    private async getDepList(params: IRnumbDate) {
        try {
            // Получаем полный список подразделений
            const fullDepList: Array<IDep> = await lastValueFrom(
                this.rs.getDepListv2(params),
            );

            // Получаем уникальные depid из talonListAll
            const depsWithTalons = new Set(
                this.talonListAll.map((talon) => Number(talon.depId)),
            );

            // Фильтруем подразделения, у которых есть талоны
            const filteredByTalons = fullDepList.filter((dep: IDep) =>
                depsWithTalons.has(Number(dep.keyId)),
            ); // Теперь фильтруем изначально полученный список депов беря только те, у которых есть талоны

            this.depList = this.mergeDuplicByText(filteredByTalons);
            if (this.depList.length === 1) this.selectedDep = this.depList[0];
        } catch (error) {
            console.error('Failed to fetch department list', error);
            this.alertService.error(
                'Не удалось загрузить список подразделений',
            );
            // this.depList = [{ keyid: -1, text: 'Все' }]; // fallback
        }
    }

    private mergeDuplicByText(deps: IDep[]): IDep[] {
        const map = new Map<string, IDep>();
        for (const dep of deps) {
            const existing = map.get(dep.text);
            if (existing) {
                existing.mergedKeyIds!.push(dep.keyId);
            } else {
                map.set(dep.text, { ...dep, mergedKeyIds: [dep.keyId] });
            }
        }
        return Array.from(map.values());
    }

    private filterActiveDays() {
        if (!this.selectedDep) {
            this.activeDays = uniqueDateTimesByDay(
                this.talonListAll.map((talon) =>
                    toDateTime(strToDate(talon.datBeginStr)),
                ),
            );
        } else {
            this.activeDays = uniqueDateTimesByDay(
                this.talonListAll
                    .filter((talon) => talon.depId === this.selectedDep?.keyId)
                    .map((talon) => toDateTime(strToDate(talon.datBeginStr))),
            );
        }
        return this.activeDays;
    }

    public getDocImg(id: number | undefined) {
        return `${this.config.getValue('hostBackend')}/img/doc/${id}.png`;
    }

    public getDocImgDefault(event: Event) {
        const elem = event.target as HTMLImageElement;
        // elem.src = `${this.config.getValue('hostBackend')}/img/doc/not.png`;
        elem.src = './assets/images/placeholders/doctor-photo.png';
    }
    public openDocInfoModal(
        doc: IDoctorSearchResult | undefined,
        event: Event,
    ) {
        event.stopPropagation();

        const doctor: Partial<IDoctor> = {
            doctorId: doc?.docId as number,
            lName: doc?.text.split(' ')[0] as string,
            fName: doc?.text.split(' ')[1] as string,
            sName: doc?.text.split(' ')[2] as string,
            infoDoc: doc?.info,
        };

        const modal = this.modalService.open(DocInfoModalComponent);
        modal.componentInstance.doc = doctor;
        modal.componentInstance.spec = doc?.specid_1;
    }
    public closeComponent() {
        this.openMobileTemplate = false;
        this.closePicker.emit();
    }
    public toggleDropdown() {
        this.showDropdown = !this.showDropdown;
    }

    public selectDep(dep: IDepartment) {
        this.pickedTalon = null;
        this.showCalendarIcon = true;
        if (dep.mergedKeyIds && dep.mergedKeyIds.length > 1) {
            this.selectedDeps = dep.mergedKeyIds;
        }
        this.headerTxt = formatUiDate(this.selectedDay);

        this.selectedDep = dep
            ? {
                  keyId: dep.keyId,
                  text: dep.text,
              }
            : null;

        this.showDropdown = false;
        this.talonListFiltered = this.filterTalons();
        this.activeDays = this.filterActiveDays();
    }

    public placeholderDep() {
        return this.selectedDep && this.selectedDep !== null
            ? this.selectedDep?.text
            : this.depPicked
              ? 'Все'
              : 'Выберите филиал';
    }

    public selectDay(day: DateTime | null) {
        this.talonListFiltered = this.filterTalons();
    }

    public filterTalons() {
        return this.talonListAll.filter((talon) => {
            return (
                Boolean(
                    this.selectedDay &&
                    talon.dtBegin &&
                    toDateTime(talon.dtBegin).hasSame(this.selectedDay, 'day'),
                ) &&
                (this.selectedDep
                    ? this.selectedDeps.length > 1 &&
                      this.selectedDeps.includes(this.selectedDep.keyId)
                        ? this.selectedDeps.includes(talon.depId)
                        : talon.depId === this.selectedDep.keyId
                    : true)
            );
        });
    }
    /* Выбор даты в календаре талонов */
    public depId: number | 0 = 0;
    public clickDate(date: DateTime) {
        this.selectedDate = date.toJSDate();

        if (!date) {
            return;
        }
        this.selectedDay = date;

        this.loadDate(this.depId);
    }
    public talonListDay: IRecTalon[] = []; // Массов дней - активный
    public calendarEnabled: boolean = true;
    public classApplied = false;
    /* Получение текущей даты в фильтре */
    // initDay(data: ITalonsDaySetParams) {
    //     // Фильтр по дню
    //     // this.selectedDay = data.dt;
    //     const newData: ITalonsDaySetParams = {
    //         dt: this.selectedDay ? this.selectedDay.toJSDate() : new Date(),
    //         dep: this.selectedDep ? this.selectedDep : undefined,
    //     };
    //     data = newData;
    //     console.log('5555', data);

    //     // const depId = data?.dep && data.dep.keyid > 0 ? data.dep.keyid : 0;
    //     const depId = data?.dep && 'keyid' in data.dep ? data.dep.keyid : 0;
    //     this.loadDate(depId);
    //     console.log('depIdinitDay', depId);
    //     this.rs.TalonsDaySetParams(data);
    // }
    /* Получение текущей даты в фильтре */
    public initDay(data: ITalonsDaySetParams) {
        // Фильтр по дню
        this.selectedDate = data.dt;
        const depId = data.dep && data.dep.keyId > 0 ? data.dep.keyId : 0;

        this.loadDate(depId);
    }

    public loadDate(depId: number) {
        const dateFilter = getDateKey(this.selectedDate);
        this.headerTxt = formatUiDate(this.selectedDay);

        this.talonListDay = this.talonList.filter(
            (item) =>
                item.dtFilter === dateFilter &&
                (item.depId === depId || depId === 0),
        );

        // All variables are unused
        // const prevDateDay = this.talonListAll.filter(
        //         (item) =>
        //             Number(item.dtFilter) < dateFilter &&
        //             (item.depId === depId || depId === 0)
        //     ),
        //     nextDateDay = this.talonListAll.filter(
        //         (item) =>
        //             Number(item.dtFilter) > dateFilter &&
        //             (item.depId === depId || depId === 0)
        //     );

        // this.prevDate = prevDateDay.length
        //     ? prevDateDay[prevDateDay.length - 1].dtBegin
        //     : null;
        // this.nextDate = nextDateDay.length ? nextDateDay[0].dtBegin : null;

        const dates = this.talonListAll
            .map((item) => item.dtFilter)
            .filter((date, index, self) => {
                return self.indexOf(date) === index;
            });

        const months = this.talonListAll
            .map((item) => String(item.dtFilter).substr(0, 6))
            .filter((month, index, self) => {
                return self.indexOf(month) === index;
            });

        this.calendarEnabled = dates.length > 1;

        this.cs.setParams({
            year_begin: DateTime.local().year,
            mounth_begin: DateTime.local().month,
            count: months.length,
            cdActive: dates.map((date) => ({
                date: date !== undefined ? date : 0,
            })),
            orderByStart: true,
            MinDate: {
                m: DateTime.local().month,
                y: DateTime.local().year,
            },
            selectDate: '',
        });
        this.cs.setSelectedDate(formatApiDate(this.selectedDate));
    }

    /* Открытие/скрытие календаря */
    public toggleClass() {
        this.calendarHandler();
        if (!this.calendarEnabled) {
            return;
        }
        this.classApplied = !this.classApplied;
        const element =
            document.getElementsByClassName('calendar-container')[0];
        if (this.classApplied === true && element) {
            element.classList.add('calendar-active');
        } else if (element) {
            element.classList.remove('calendar-active');
        }
    }

    public calendarHandler() {
        this.isCalendarActive = !this.isCalendarActive;
    }

    public toHistory(event: MouseEvent) {
        event.stopPropagation();
        this.router.navigate([`/home/history`]);
        // this.dialogRef.close();
    }

    public toRecord(event: MouseEvent) {
        event.stopPropagation();
        this.router.navigate([`/home/record-services`]);
        // this.dialogRef.close();
    }
    /* Блокировка выбора талона */
    public talonDisable(talon: IRecTalon): boolean {
        // if (!this.params?.srv) return false;
        return this.params?.srv?.isTelemed === talon.isTelemed;
    }
    public buttonAcceptplaceholder() {
        if (this.pickedTalon) {
            if (this.params?.srv?.isTelemed !== this.pickedTalon?.isTelemed) {
                return 'Это номерок для другой услуги';
            }
            return 'Выбрать';
        }
        return 'Выберите время';
    }
}
